<template>
<transition name="fade">
    <li class="bg-white pa4 mb1 br2">
        <small class="f6 moon-gray fl">{{ tweet.author }} said: </small>
        <p class="lh-copy mt4 tl near-black f5 pa4 bl bw1 b--light-green break-p">
            {{ tweet.content }}
        </p>
        <div class="fr w-100">
            <span v-if="keep" class="silver fl hover-light-red f6 pointer mb2 bg-transparent" @click.prevent="removeTweet(tweet)"><i class="fas fa-trash-alt"></i></span>
            <p class="moon-gray f6 fr mt0 mb0">{{ ago(tweet.created) }}</p>
        </div>
    </li>
</transition>
</template>

<script>
import Moment from 'moment'

export default {
  props: ['tweet', 'keep'],
  methods: {
    ago: function (data) {
      return Moment(data).fromNow()
    },
    removeTweet: function (tweet) {
      this.$emit('removeTweet', tweet)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tweet-component.vue